(function () {
  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches(sel)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function initRoot(root) {
    if (!root || root.dataset.mnOffersReady === '1') return;
    root.dataset.mnOffersReady = '1';

    root.querySelectorAll('[data-mn-offer-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = closest(btn, '[data-mn-offer]');
        if (!card) return;
        var wasActive = card.classList.contains('is-active');
        root.querySelectorAll('[data-mn-offer]').forEach(function (c) {
          c.classList.remove('is-active');
          var t = c.querySelector('[data-mn-offer-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (!wasActive) {
          card.classList.add('is-active');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mn-offers]').forEach(initRoot);
  }

  function shineOffers(el) {
    if (!el) return;
    var old = el.querySelector('.mn-offers__shine');
    if (old) old.remove();
    el.classList.remove('is-shine');
    void el.offsetWidth;
    el.classList.add('is-shine');

    var w = Math.max(el.offsetWidth, 1);
    var h = Math.max(el.offsetHeight, 1);
    var radius = 10;
    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('class', 'mn-offers__shine');
    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    svg.setAttribute('aria-hidden', 'true');

    function makeRect(cls) {
      var rect = document.createElementNS(svgNS, 'rect');
      rect.setAttribute('class', cls);
      rect.setAttribute('x', '1.5');
      rect.setAttribute('y', '1.5');
      rect.setAttribute('width', String(Math.max(w - 3, 1)));
      rect.setAttribute('height', String(Math.max(h - 3, 1)));
      rect.setAttribute('rx', String(radius));
      rect.setAttribute('ry', String(radius));
      rect.setAttribute('pathLength', '100');
      return rect;
    }

    svg.appendChild(makeRect('mn-offers__shine-tail'));
    svg.appendChild(makeRect('mn-offers__shine-head'));
    el.appendChild(svg);

    window.setTimeout(function () {
      if (svg.parentNode) svg.parentNode.removeChild(svg);
      el.classList.remove('is-shine');
    }, 1600);
  }

  function whenOffersInView(el, done) {
    var start = performance.now();
    function tick() {
      var top = el.getBoundingClientRect().top;
      if ((top < 130 && top > -20) || performance.now() - start > 1400) {
        done();
        return;
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  document.addEventListener('click', function (e) {
    var link = closest(e.target, '[data-mn-scroll-offers]');
    if (!link) return;
    var target = document.querySelector('.mn-offers--pdp') || document.getElementById('offers');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    whenOffersInView(target, function () {
      shineOffers(target);
    });
  });

  var scheduled = false;
  function scheduleInit() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initAll();
    });
  }

  var observer = new MutationObserver(scheduleInit);
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  window.MenaraniOffers = {
    init: initAll,
  };
})();
